// eslint-disable-next-line no-underscore-dangle
export default function _tocGroup() {
    /**
     * @const {string} - The selector used to find the table of contents container
     */
    const TOC_SELECTOR = '.toc';
    const TOC_LIST_SELECTOR = '.toc__list';
    const TOC_HEADING = '.toc__heading';
    const PAGE_CONTENT_SELECTOR = '#main';

    /**
     * The Table of contents class
     * @param {HTMLElement} - Passed the html element for a ToC group
     * @class
     */
    class TocGroup {
        constructor(tocGroup) {
            // The ToC group HTML element
            this.tocGroup = tocGroup;

            // Get the list element
            this.itemList = this.tocGroup.querySelector(TOC_LIST_SELECTOR);

            this.headings = this.getContentHeadings();

            if (this.headings.length > 0) {
                this.addHeadingEventListener();
                this.addHeadingIDs(this.headings);
                this.wrapTocMenu();
                this.populateTocMenu(this.headings);
            }

            // Get the location hash
            const locationHash = window.location.hash.replace('#', '');

            // Check that we got something back from the url
            if (locationHash) {
                // Scroll to the content
                // this.openTab(locationHash);
            }
        }

        /**
         * Toggles the aria state
         * @param {event} event - The firing event
         * @method
         */
        toggleTocMenu(event) {
            const currentState = event.srcElement.getAttribute('aria-expanded');
            if (currentState === 'false') {
                event.srcElement.setAttribute('aria-expanded', 'true');
            } else {
                event.srcElement.setAttribute('aria-expanded', 'false');
            }
        }

        /**
         * Add listener for the button/heading click
         * @method
         */
        addHeadingEventListener() {
            const toggle = document.querySelector(TOC_HEADING);
            toggle.addEventListener('click', this.toggleTocMenu);
        }

        /**
         * Function that adds IDs to the headings
         */
        addHeadingIDs(headings) {
            headings.forEach((heading) => {
                const id = this.textToID(heading.innerHTML);
                heading.setAttribute('id', id);
            });

            return false;
        }

        /**
         * Function that adds the headings to the Table of Contents list
         */
        populateTocMenu(headings) {
            headings.forEach((heading) => {
                const id = this.textToID(heading.innerHTML);

                const itemnode = document.createElement('li');
                const linknode = document.createElement('a');

                linknode.setAttribute('href', `#${id}`);
                linknode.innerHTML = `<svg class="svg-icon"><use href="#circle-arrow-right"></svg>${heading.innerHTML}`;

                itemnode.classList.add('toc__item');
                itemnode.appendChild(linknode);

                if (heading.innerHTML.trim().length > 0) {
                    this.itemList.appendChild(itemnode);
                }
            });

            return false;
        }

        /**
         * Function to wrap the table of contents and the FIRST content component after the ToC
         */
        wrapTocMenu() {
            const wrapper = document.createElement('div');

            wrapper.classList.add('toc-wrap');
            document
                .querySelector('.page-layout__body #main')
                .insertBefore(wrapper, this.tocGroup);

            wrapper.appendChild(this.tocGroup);

            // Get the first content item
            const firstContentElement =
                document.querySelector('.toc-wrap').nextElementSibling;
            wrapper.appendChild(firstContentElement);
        }

        /**
         * Function to convert inner text to an HTML ID
         * @param {string} text
         * @returns
         */
        textToID(text) {
            return text.replace(/\W/g, '-').toLowerCase();
        }

        /**
         * Function that retrieves the h2s within the content area
         */
        getContentHeadings() {
            const page = document.querySelector(PAGE_CONTENT_SELECTOR);
            const headingsExist = !!page.querySelector('h2');

            if (headingsExist) {
                const headingElements = page.querySelectorAll('h2');
                return headingElements;
            }

            return false;
        }
    }

    /**
     * Function that initializes the tab groups on the page
     */
    function initializeToc() {
        const DOMItem = document.querySelector(TOC_SELECTOR);
        DOMItem.tocGroup = new TocGroup(DOMItem);
    }

    /**
     * @const {boolean}
     */
    const tocExists = !!document.querySelector(TOC_SELECTOR);

    // If the module exists, do whatever we need to
    if (tocExists) {
        initializeToc();
    }
}

_tocGroup();
